export default "__VITE_ASSET__CZeMcRWx__"